/** Id constants for elements throughout the codebase */ export var ElementIds;
(function(ElementIds) {
    /** Left nav element ids */ ElementIds["MyDayNavButton"] = "myDayNavButton";
    ElementIds["MyTasksNavButton"] = "myTasksNavButton";
    ElementIds["MyPlansNavButton"] = "myPlansNavButton";
    ElementIds["MyPortfoliosNavButton"] = "myPortfoliosNavButton";
    ElementIds["LeftNavNewPlanButton"] = "leftNavNewPlanButton";
    /** My Day element ids */ ElementIds["MyDayTaskSuggestionsButton"] = "myDayTaskSuggestionsButton";
    /** My Tasks element ids */ ElementIds["MyTasksAllPivot"] = "myTasksAllPivot";
    ElementIds["MyTasksPrivatePivot"] = "myTasksPrivatePivot";
    ElementIds["MyTasksAssignedToMePivot"] = "myTasksAssignedToMePivot";
    ElementIds["MyTasksFlaggedEmailsPivot"] = "myTasksFlaggedPivot";
    /** My Plans element ids */ ElementIds["MyPlansRecentPivot"] = "myPlansRecentPivot";
    ElementIds["MyPlansSharedPivot"] = "myPlansSharedPivot";
    ElementIds["MyPlansPersonalPivot"] = "myPlansPersonalPivot";
    ElementIds["MyPlansPinnedPivot"] = "myPlansPinnedPivot";
    ElementIds["MyPlansMyTeamsPivot"] = "myPlansMyTeamsPivot";
    ElementIds["MyPlansRecommendedPivot"] = "myPlansRecommendedPivot";
    ElementIds["MyPlansNewPlanButton"] = "myPlansNewPlanButton";
    /** My Portfolios element ids */ ElementIds["MyPortfoliosNewPortfolioButton"] = "myPortfoliosNewPortfolioButton";
    /** Plan view element ids */ ElementIds["BoardViewPivot"] = "boardViewPivot";
    ElementIds["ScheduleViewPivot"] = "scheduleViewPivot";
    ElementIds["ChartsViewPivot"] = "chartsViewPivot";
    ElementIds["GridViewPivot"] = "gridViewPivot";
    ElementIds["GoalsViewPivot"] = "goalsViewPivot";
    ElementIds["BasicPlanGoalsAttachSourcesButton"] = "basicPlanGoalsAttachSourcesButton";
    ElementIds["BasicPlanGoalsResourcesButton"] = "basicPlanGoalsResourcesButton";
    ElementIds["HomeViewPivot"] = "homeViewPivot";
    ElementIds["TimelineViewPivot"] = "timelineViewPivot";
    ElementIds["GridViewSecondColumn"] = "gridViewSecondColumn";
    ElementIds["HeaderJoinButtonTooltip"] = "joinButtonTooltip";
    ElementIds["HeaderShareButton"] = "headerShareButton";
    ElementIds["HeaderMoreOptionsButton"] = "headerMoreOptionsButton";
    ElementIds["TaskFiltersButton"] = "taskFiltersButton";
    ElementIds["CopilotButton"] = "copilotButton";
    ElementIds["GsdGoalsSection"] = "gsdGoalsSection";
    ElementIds["GsdResourcesSection"] = "gsdResourcesSection";
    ElementIds["PremiumAddGoalButton"] = "premiumAddGoalButton";
    ElementIds["AddFilesButton"] = "addFilesButton";
    ElementIds["ViewOptionsButton"] = "viewOptionsCommand";
    ElementIds["StatusReportViewPivot"] = "statusReportViewPivot";
    ElementIds["PremiumGoalsViewPivot"] = "premiumGoalsViewPivot";
    ElementIds["PremiumPlanGroupByButton"] = "premiumPlanGroupByButton";
    ElementIds["PeopleViewPivot"] = "peopleViewPivot";
    /** Create Plan Element ids */ ElementIds["FromMicrosoftPivot"] = "fromMicrosoftPivot";
    ElementIds["SharedPivot"] = "sharedPivot";
    ElementIds["CreatedByMePivot"] = "createdByMePivot";
    /** Task details dialog element ids */ ElementIds["TaskDetailsMoreOptionsButton"] = "taskDetailsMoreOptionsButton";
    ElementIds["TaskDetailsStartDateCalendarIcon"] = "taskDetailsStartDateCalendarIcon";
    /** Share plan dialog */ ElementIds["SharePlanCreateGroupPivot"] = "sharePlanCreateGroupPivot";
    ElementIds["SharePlanExistingGroupPivot"] = "sharePlanExistingGroupPivot";
    ElementIds["SharePlanPeoplePivot"] = "sharePlanPeoplePivot";
    ElementIds["SharePlanAgentsPivot"] = "sharePlanAgentsPivot";
    /** Plan settings panel */ ElementIds["PlanSettingsGeneralTab"] = "planSettingsGeneralTab";
    ElementIds["PlanSettingsTitle"] = "planSettingsTitle";
    ElementIds["PlanSettingsContent"] = "planSettingsContent";
    /** Floating Action Button (FAB) */ ElementIds["FABButton"] = "fabButton";
})(ElementIds || (ElementIds = {}));
export var ViewElementIds;
(function(ViewElementIds) {
    ViewElementIds["PlanView"] = "planView";
    ViewElementIds["BasicPlanView"] = "basicPlanView";
    ViewElementIds["PremiumPlanView"] = "premiumPlanView";
    ViewElementIds["BasicTaskDetailsView"] = "basicTaskDetailsView";
    ViewElementIds["PremiumTaskDetailsView"] = "premiumTaskDetailsView";
    ViewElementIds["MyTasksView"] = "myTasksView";
    ViewElementIds["MyDayView"] = "myDayView";
    ViewElementIds["MyPlanView"] = "myPlanView";
})(ViewElementIds || (ViewElementIds = {}));
export var BoardViewElementClassNames;
(function(BoardViewElementClassNames) {
    BoardViewElementClassNames["TaskBoardAddTaskToggleButton"] = "addButton";
    BoardViewElementClassNames["AddTaskCardAddTaskButton"] = "addTaskButton";
})(BoardViewElementClassNames || (BoardViewElementClassNames = {}));
/** The left nav collapse threshold in px */ export const LeftNavCollapseThreshold = 1024;
/** The number of shimmer rows to show in the grid view when loading tasks */ export const DefaultNumberOfGridShimmerRows = 15;
/** The number of max characters to show before truncation in the bucket title related strings */ export const MaxBucketTitleCharacters = 18;
/** The maximum number of characters displayed for plan title in toasts when pinning */ export const MaxPlanTitleCharactersForPinning = 25;
/** The maximum number of characters displayed for plan title in toasts when unpinning */ export const MaxPlanTitleCharactersForUnpinning = 40;
